import ExportDropDown from "@/components/ExportDropDown.vue";
import AppIcon from "@/components/AppIcon";
import CSVIcon from "@/components/icons/CSVIcon.vue";
import AppDropdownItem from "@/components/AppDropdownItem.vue";
import { EVENTS } from "@/utils";
export default {
  name: "ContentExportDropDown",
  emits: ["download-content-csv"],
  components: {
    ExportDropDown,
    AppIcon,
    CSVIcon,
    AppDropdownItem
  },
  data() {
    return {
      export_options: [{
        value: "primelis_content",
        text: "Export Primelis Content",
        sub_category: "primelis_content",
        icon: "CSVIcon",
        track_event: "userExportedPrimelisContentCSV"
      }, {
        value: "all_content",
        text: "Export All Content",
        sub_category: "all_content",
        icon: "CSVIcon",
        track_event: "userExportedAllContentCSV"
      }],
      export_options_categories: ["primelis_content", "all_content"]
    };
  },
  props: {
    isDownloadRunning: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async handleDownload(download_option) {
      //console.log("[handle download clicked]");
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: download_option.track_event,
        properties: {}
      });
      this.$emit("download-content-csv", download_option.value);
    }
  }
};